export const steps = {
    default : "default",
    technicalStaff :"technicalStaff",
    successInscriptionTournament : "successInscriptionTournament",
    declineInvitation : "declineInvitation",
    successDeclineInvitation : "successDeclineInvitation"
}